import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";

const BANK_ACCOUNT_API_URL = process.env.REACT_APP_BANK_ACCOUNT_API_BASE_URL;
const getAllBankInformation = (): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/bank-information",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrieve List of All Bank Information";
      throw error;
    });
};

const saveAllBankInformation = (bankAccount: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: BANK_ACCOUNT_API_URL + "/bank-information",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: bankAccount,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

export { getAllBankInformation, saveAllBankInformation };
